export default __webpack_public_path__ + "static/media/pixel.474f62a8.png";